import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'lm-large-image-is',
  standalone: false,
  template: `
      <img [src]="imageUrl" />
      <a id="largeImageIsDownload" style="display: none;"></a>
  `,
  styles: [ `
    :host {
      display: flex;
      justify-content:center;
    }
  ` ]
})

export class LMLargeImageIsDialogComponent {
  @Input() imageUrl: string | undefined;
  @HostBinding('attr.data-automation-id') automationId = 'lm-large-image-is-modal';

  constructor() { }
}